/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import SiteShell from './SiteShell.jsx'

const FEATURES = [
  { t: 'دسترسی لحظه‌ای و همیشه همراه', d: 'مشاهده آنلاین و آفلاین برنامه تمرینی، ست‌ها و تکرارها در محیط باشگاه روی گوشی همراه.' },
  { t: 'ویدیوهای اجرای صحیح تمرین‌ها', d: 'مشاهده آموزش تصویری و جزئیات تکنیکی هر تمرین جهت جلوگیری از آسیب‌دیدگی.' },
  { t: 'ثبت و آنالیز پیشرفت', d: 'امکان ثبت دقیق رکوردهای وزنه، تکرارها و مشاهده روند صعودی آمادگی جسمانی شما.' },
]

export default function MoveOnPage() {
  return (
    <SiteShell variant="moveon">
      <section className="pg-move">
        <span className="pg-badge">نسخه‌ی بتا</span>
        <h1>انتقال به پلتفرم جدید سکویا فیتنس</h1>
        <p>
          ورزشکار عزیز، جهت ارتقای کیفیت آموزش و پیگیری دقیق‌تر تمرینات، از این به بعد دسترسی به تمامی <strong>برنامه‌های تمرینی و تغذیه</strong> فقط از طریق پلتفرم و وب‌اپلیکیشن جدید سکویا امکان‌پذیر هست.
        </p>
        <div className="pg-notice">نسخه‌های قدیمی و فایل‌های ارسالی قبلی منقضی شده‌اند.</div>
        <a className="pg-cta" href="https://app.sequoia.fitness">
          ورود به اپلیکیشن
        </a>
      </section>
      <section className="pg-steps">
        <h2>چطوری برنامه‌ام رو دریافت کنم؟</h2>
        <ol>
          <li>
            <span>مرحله اول</span>
            <p>روی دکمه «ورود به اپلیکیشن» کلیک کن.</p>
          </li>
          <li>
            <span>مرحله دوم</span>
            <p>از روی آیکن پایین سمت چپ در صفحه‌ی ورود، راهنمایی‌های بیشتر رو ببین.</p>
          </li>
        </ol>
      </section>
      <section className="pg-grid3">
        {FEATURES.map((f) => (
          <div className="pg-card" key={f.t}>
            <h3>{f.t}</h3>
            <p>{f.d}</p>
          </div>
        ))}
      </section>
    </SiteShell>
  )
}
